<div class="container">

    <app-header-dialog [iconName]="'mail_outline'">
 Certificados para Palestrantes
  </app-header-dialog>

  <div *ngIf="certificateForm">

    <div class="content">

      <div style="margin: 20px 20px 0 20px; display: flex; flex-direction: row; justify-content: space-between;">

        <mat-form-field style='width: 440px; margin: 0 30px 0 30px;' appearance="outline">
          <mat-label>QRCode</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="certificateForm.controls.staff_qrCode"
            autocomplete="off">
        </mat-form-field>

        <mat-form-field style='width: 440px; margin: 0 30px 0 30px;' appearance="outline">
          <mat-label>Participaçao</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="certificateForm.controls.staff_role"
            autocomplete="off">
        </mat-form-field>

        <div>
          <input #file type="file" accept='image/*' style='display:none;' (change)="previewImage($event)" />
          <button style='margin-right: 20px;' (click)='file.click()' mat-raised-button>
            <mat-icon class='icon-add'>image_search</mat-icon>
          </button>
        </div>

      </div>

      <div style="max-width: 600px; margin: auto;">
        <div>1754 X 1240 pixels</div>
        <img style="width: 100%;" [src]="storedImage" *ngIf="storedImage" />
      </div>
    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button matTooltip='Insert' mat-raised-button (click)="matDialogRef.close(['ok',certificateForm, objectImage])"
        [disabled]="certificateForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
    </div>

  </div>

</div>